export default __webpack_public_path__ + "static/media/crown.fe1ab585.webm";